"use client"

import { useState } from "react"
import Link from "next/link"
import { ArrowUp } from "lucide-react"
import styles from "./LandingPageFooter.module.css"
import LogoOnlyImage from "../Logo/Logo"
import { subscribeToNewsletter } from "@/app/actions/newsletterActions"

interface FooterProps {
  backgroundColor?: string
}

export default function Footer({ backgroundColor = "#8CD867" }: FooterProps) {
  const [isHovered, setIsHovered] = useState<string | null>(null)

  const [email, setEmail] = useState("")
const [newsletterStatus, setNewsletterStatus] = useState<{
  success: boolean;
  error?: string;
  message?: string;
} | null>(null)
const [isSubmitting, setIsSubmitting] = useState(false)
  const currentYear = new Date().getFullYear()

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
  const handleNewsletterSubmit = async (formData: FormData) => {
    setIsSubmitting(true)
    setNewsletterStatus(null)
    
    try {
      const result = await subscribeToNewsletter(formData)
      setNewsletterStatus(result)
      
      if (result.success) {
        setEmail("")
      }
    } catch (error) {
      setNewsletterStatus({
        success: false,
        error: "Failed to subscribe. Please try again later."
      })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <footer className={styles.footer} style={{ backgroundColor }}>
      <div className={styles.container}>
        <div className={styles.topSection}>
          <div className={styles.headlineSection}>
            <h2 className={styles.headline}>
              Exactly what you
              <br />
              were thinking.
            </h2>
            <div className={styles.logoWrapper}>
              <div className={styles.logo}>
                <LogoOnlyImage width={40} height={40}/>
              </div>
            </div>
          </div>

          {/* <div className={styles.linksSection}>
            <div className={styles.linkColumn}>
              <Link href="/support" className={styles.link}>
                Support
              </Link>
              <Link href="/about-us" className={styles.link}>
                About Us
              </Link>
            </div>
            <div className={styles.linkColumn}>
              <Link href="/faq" className={styles.link}>
                FAQ
              </Link>

            </div>
            <div className={styles.linkColumn}>


            </div>

          </div> */}
        </div>

        <div className={styles.newsletter}>
  {newsletterStatus?.success ? (
    <p className={styles.newsletterText}>
      <span className={styles.circle}>✓</span> 
      Thanks for subscribing!
    </p>
  ) : (
    <>
      <p className={styles.newsletterText}>
        <span className={styles.circle}><svg width="27" height="13" viewBox="0 0 27 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.51374 1.88486C5.25497 1.88486 4.18309 2.3339 3.31459 3.21535C2.45158 4.08571 2.01184 5.18337 2.01184 6.46396C2.01184 7.74456 2.46807 8.93092 3.36406 9.80128C4.26004 10.6661 5.29894 11.1096 6.46427 11.1096C7.62959 11.1096 8.81691 10.6606 9.68541 9.7791C10.5539 8.88657 10.9992 7.77782 10.9992 6.50277C10.9992 5.22772 10.5649 4.10234 9.7074 3.2209C8.84989 2.33945 7.77801 1.8904 6.51374 1.8904V1.88486ZM6.43679 13C4.84271 13 3.39154 12.4345 2.11078 11.3203C0.709089 10.084 0 8.44307 0 6.44179C0 4.44051 0.648626 3.15437 1.92389 1.8904C3.20465 0.637527 4.75476 0 6.53573 0C8.3167 0 9.83383 0.648614 11.0926 1.91812C12.3569 3.19318 13 4.73987 13 6.5194C13 8.29893 12.3514 9.86226 11.0816 11.1041C9.80634 12.3625 8.23975 12.9945 6.43679 12.9945" fill="#1E1C1C"/>
<path d="M12.2121 6.69702C12.2121 8.1112 11.0656 9.25762 9.65145 9.25762C8.23727 9.25762 7.09085 8.1112 7.09085 6.69702C7.09085 5.28283 8.23727 4.13641 9.65145 4.13641C11.0656 4.13641 12.2121 5.28283 12.2121 6.69702Z" fill="#1E1C1C"/>
<path d="M20.5137 1.88486C19.255 1.88486 18.1831 2.3339 17.3146 3.21535C16.4516 4.08571 16.0118 5.18337 16.0118 6.46396C16.0118 7.74456 16.4681 8.93092 17.3641 9.80128C18.26 10.6661 19.2989 11.1096 20.4643 11.1096C21.6296 11.1096 22.8169 10.6606 23.6854 9.7791C24.5539 8.88657 24.9992 7.77782 24.9992 6.50277C24.9992 5.22772 24.5649 4.10234 23.7074 3.2209C22.8499 2.33945 21.778 1.8904 20.5137 1.8904V1.88486ZM20.4368 13C18.8427 13 17.3915 12.4345 16.1108 11.3203C14.7091 10.084 14 8.44307 14 6.44179C14 4.44051 14.6486 3.15437 15.9239 1.8904C17.2047 0.637527 18.7548 0 20.5357 0C22.3167 0 23.8338 0.648614 25.0926 1.91812C26.3569 3.19318 27 4.73987 27 6.5194C27 8.29893 26.3514 9.86226 25.0816 11.1041C23.8063 12.3625 22.2397 12.9945 20.4368 12.9945" fill="#1E1C1C"/>
<path d="M26.2121 6.69702C26.2121 8.1112 25.0656 9.25762 23.6515 9.25762C22.2373 9.25762 21.0908 8.1112 21.0908 6.69702C21.0908 5.28283 22.2373 4.13641 23.6515 4.13641C25.0656 4.13641 26.2121 5.28283 26.2121 6.69702Z" fill="#1E1C1C"/>
</svg>
</span> Sign up for our newsletter
      </p>
      <div className={styles.inputWrapper}>
        <input 
          type="email" 
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address" 
          className={styles.emailInput}
          required
          disabled={isSubmitting}
        />
        <button 
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            const formData = new FormData();
            formData.append('email', email);
            handleNewsletterSubmit(formData);
          }}
          className={styles.submitButton}
          disabled={isSubmitting}
        >
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="14" fill="#1E1C1C"/>
<path fillRule="evenodd" clipRule="evenodd" d="M12.5 21.6667C12.5 21.2065 12.8731 20.8334 13.3333 20.8334L23.3333 20.8334C24.714 20.8334 25.8333 19.7141 25.8333 18.3334L25.8333 15.0001C25.8333 14.5398 26.2064 14.1667 26.6667 14.1667C27.1269 14.1667 27.5 14.5398 27.5 15.0001L27.5 18.3334C27.5 20.6346 25.6345 22.5001 23.3333 22.5001L13.3333 22.5001C12.8731 22.5001 12.5 22.127 12.5 21.6667Z" fill={backgroundColor}/>
<path fillRule="evenodd" clipRule="evenodd" d="M12.7441 22.256C12.4186 21.9306 12.4186 21.4029 12.7441 21.0775L16.0774 17.7442C16.4028 17.4187 16.9305 17.4187 17.2559 17.7442C17.5814 18.0696 17.5814 18.5972 17.2559 18.9227L14.5118 21.6667L17.2559 24.4108C17.5814 24.7363 17.5814 25.2639 17.2559 25.5893C16.9305 25.9148 16.4028 25.9148 16.0774 25.5893L12.7441 22.256Z" fill={backgroundColor}/>
</svg>

        </button>
      </div>
      {newsletterStatus?.error && (
        <p style={{ color: '#d32f2f', fontSize: '14px', marginTop: '8px' }}>
          {newsletterStatus.error}
        </p>
      )}
    </>
  )}
</div>

        <div className={styles.bottomSection}>
          <button onClick={scrollToTop} className={styles.backToTop}>
            Back to top
          </button>
          <div className={styles.legalLinks}>
            <Link href="/privacy-policy" className={styles.legalLink}>
              Privacy Policy
            </Link>
            <Link href="/impressum"className={styles.legalLink} >
          Impressum
          </Link>
            {/* <Link href="/imprint" className={styles.legalLink}>
              Imprint
            </Link>
            <Link href="/affiliation" className={styles.legalLink}>
              Affiliation
            </Link> */}
            <Link href="/terms-of-service" className={styles.legalLink}>
              Terms & Conditions
            </Link>
            <span className={styles.copyright}>© {currentYear}</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
